import { useEffect } from "react";
import { Button } from "../components/Button/Button";
import { Card } from "../components/Card/Card";
import { Container } from "../components/Container/Container";
import { CTASection } from "../components/CTASection/CTASection";
import { Section } from "../components/Section/Section";
import { ServiceCard } from "../components/ServiceCard/ServiceCard";
import { credibility, processSteps, services } from "../content/site";
import { setPageMeta } from "../utils/metadata";
import * as styles from "./pages.css";

export function Home() {
  useEffect(() => {
    setPageMeta(
      "IT Consulting & Software Delivery",
      "Ayro Technologies helps organisations assess systems, shape decisions, build bespoke software, and deliver technical projects."
    );
  }, []);

  return (
    <>
      <section className={styles.hero}>
        <Container>
          <div className={styles.heroGrid}>
            <div className={styles.heroContent}>
              <span className={styles.eyebrow}>Ayro Technologies</span>
              <h1 className={styles.heroTitle}>
                Practical IT consulting for complex systems and delivery work.
              </h1>
              <p className={styles.lead}>
                We help teams understand technical risk, make better platform decisions,
                build useful software, and keep delivery moving with clear engineering
                judgement.
              </p>
              <div className={styles.actions}>
                <Button href="/contact">Discuss a project</Button>
                <Button href="/services" variant="secondary">
                  Explore services
                </Button>
              </div>
            </div>
            <div className={styles.heroVisual} aria-hidden="true">
              <div className={styles.visualPanel}>
                <h2 className={styles.visualTitle}>
                  Consulting, audits, software, and project control from one technical
                  partner.
                </h2>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <Section tone="alt">
        <Container>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>What we help with</h2>
            <p className={styles.mutedText}>
              Ayro works where business needs meet technical complexity: existing systems,
              new products, delivery pressure, and decisions that need a clear view.
            </p>
          </div>
          <div className={styles.gridFour}>
            {services.map((service, index) => (
              <ServiceCard
                key={service.title}
                index={index + 1}
                title={service.title}
                summary={service.summary}
                details={service.details}
              />
            ))}
          </div>
        </Container>
      </Section>

      <Section>
        <Container>
          <div className={styles.metricGrid}>
            {credibility.map((item) => (
              <Card key={item.title} title={item.title}>
                <p>{item.text}</p>
              </Card>
            ))}
          </div>
        </Container>
      </Section>

      <Section tone="alt">
        <Container>
          <div className={styles.split}>
            <div>
              <span className={styles.eyebrow}>Approach</span>
              <h2 className={styles.sectionTitle}>
                Structured decisions. Controlled delivery. Practical outcomes.
              </h2>
              <p className={styles.mutedText}>
                We bring enough structure to expose risk, align stakeholders, and move
                technical work forward without unnecessary ceremony.
              </p>
            </div>
            <div className={styles.gridTwo}>
              {processSteps.map((step) => (
                <Card key={step.title} title={step.title}>
                  <p>{step.text}</p>
                </Card>
              ))}
            </div>
          </div>
        </Container>
      </Section>

      <CTASection />
    </>
  );
}
